import React from "react";
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom";

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Privacy from './components/Privacy';
import Rankings from './components/Rankings';

import './App.css';

function AppContent() {
  const location = useLocation();
  const hideHeader = location.pathname === "/rankings";

  return (
    <>
      {!hideHeader && <Header />}
      <Switch>
        <Route path="/privacy">
          <Privacy />
        </Route>
        <Route path="/rankings">
          <Rankings />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <Router>
        <AppContent />
      </Router>
      <Footer />
    </div>
  );
}
